import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { AxiosError } from "axios";
import { useAtom } from "jotai";
import { ChangeEvent, FC, useState } from "react";
import { modalNewDeliveryCompany } from "../../../atoms/atom";
import { IAppBarProps } from "../../../interfaces/IAppBarProps";
import { DocumentsService } from "../../../services/DocumentService";
import { useUtils } from "../../../utils/utilFunctions";
import { useAlert } from "../../contextProviders/AlertProvider";

const CreateCompanyModal: FC<IAppBarProps> = (props: IAppBarProps) => {
	const [cnpj, setCnpj] = useState('');
	const [open, setOpen] = useAtom(modalNewDeliveryCompany);
	const { showAlert, showError } = useAlert();
	const { validateCNPJ, formatDocument, validateCPF } = useUtils();

	return (
		<Dialog
			open={open}
			onClose={() => setOpen(false)}
			id='modal-forms'
		>
			<DialogTitle>Adicionar empresa matriz ou filial</DialogTitle>
			<DialogContent id="modal-forms-content">
				<TextField
					sx={{width: '300px !important'}}
					label="CPF/CNPJ da empresa"
					id="cnpj-form"
					size="medium"
					inputProps={{ maxLength: 18}}
					value={cnpj}
					onChange={(e: ChangeEvent<HTMLInputElement>) => setCnpj(formatDocument(e.target.value.trim()))}
					helperText="Insira o CPF/CNPJ da empresa"
				/>
			</DialogContent>
			<DialogActions>
				<Button id="close-form-button" onClick={() => setOpen(false)}>
					Fechar
				</Button>
				<Button
					disabled={!validateCNPJ(cnpj) && !validateCPF(cnpj)}
					id="create-form-button"
					color="success"
					onClick={() => save()}
				>
					Salvar
				</Button>
			</DialogActions>
		</Dialog>
	);

	async function save() {
		try {
			const response = await new DocumentsService().createCompany(props.modulo, cnpj);
			if (response.status === 200) {
				showAlert('Formulário criado com sucesso', "success");
				setOpen(false);
			}
		} catch (error) {
			if (!(error instanceof AxiosError && error.response)) return;
			switch (error.response?.status) {
				case 404:
					showError("Nenhuma empresa encontrada para o CNPJ");
					break;
				case 406:
					showError("O CNPJ desta empresa não pertence à esta matriz!");
					break;
				default:
					showError();
					break;
			}
		}
		setCnpj('');
	}
}

export default CreateCompanyModal;